import Image from 'next/image'
import { InView } from 'react-intersection-observer'
// COMPONENTS
import Button from '@/components/newButton/Button'
import useMediaQuery from '@/utils/publicApi'
import styles from './home.module.scss'
// IMAGES
import imageMobile1 from '../../public/match-quiz/mobile/img-1.png'
import imageDesktop1 from '../../public/match-quiz/home/img-1.png'
import imageMobile2 from '../../public/match-quiz/mobile/img-2.png'
import imageDesktop2 from '../../public/match-quiz/home/img-2.png'
import imageMobile3 from '../../public/match-quiz/mobile/img-3.png'
import imageDesktop3 from '../../public/match-quiz/home/img-3.png'
import imageMobile4 from '../../public/match-quiz/mobile/img-4.png'
import imageDesktop4 from '../../public/match-quiz/home/img-4.png'

export default function Home({ setInitQuiz, setIsButtonVisible }) {
  const isMobile = useMediaQuery('(max-width:600px)')
  return (
    <div className={styles.container}>
      <section className={styles.grid}>
        <div className={styles.sectionHeader}>
          <picture>
            <source
              media="(max-width: 600px)"
              srcSet="/match-quiz/mobile/wizard-dane-stars.webp"
            />
            <img
              src="/match-quiz/home/wizard-dog.svg"
              alt="Great Dane dog with a purple wizard hat"
            />
          </picture>
          <h1>Dog Breed Quiz</h1>
          <h3>Which Breed is Right for You?</h3>
          <div className={styles.contentBnt}>
            <Button
              title="Start quiz"
              theme={['pink-solid', 'large']}
              onClick={() => setInitQuiz(true)}
              style={{ width: '300px' }}
            />
          </div>
        </div>

        <div className={styles.sectionText}>
          <div className={styles.article_A}>
            <div className={styles.text_A}>
              <p>
                Adding a new puppy to the family is exciting, but we understand
                that choosing the right breed can be quite a challenge,
                especially if you’ve never had a dog before. After all, you’re
                committing to caring for a dog who will be your close companion
                for its entire life. We’re sure you have lots of questions
                running through your mind! In particular, “What dog should I
                get?” and “What is the right dog for me?” Finding your perfect
                puppy match begins with a little research, and our puppy quiz is
                the perfect place to start.
              </p>
            </div>
            {!isMobile && (
              <picture className={styles.image_A}>
                <Image
                  src={imageDesktop1}
                  style={{ width: '100%', height: 'auto' }}
                  alt="Young girl hugging Beagle dog"
                  width={370}
                  height={220}
                  loading="lazy"
                  placeholder="blur"
                  blurDataURL={`/_next/image?url=${imageDesktop1}&w=16&q=1`}
                />
              </picture>
            )}
            {isMobile && (
              <picture className={styles.imgMobile}>
                <Image
                  src={imageMobile1}
                  style={{ width: '100%', height: 'auto' }}
                  alt="Young girl hugging Beagle dog"
                  loading="lazy"
                  placeholder="blur"
                  blurDataURL={`/_next/image?url=${imageMobile1}&w=16&q=1`}
                />
              </picture>
            )}
          </div>
          <InView onChange={setIsButtonVisible}>
            <div className={styles.article_B}>
              <div className={styles.text_B}>
                <h2>What to Consider When Choosing a Dog Breed</h2>
                <p>
                  When choosing a dog breed, you’ll want to start by considering
                  your living space. Do you live in an apartment, a large house,
                  or something in between? Do you have a fenced-in yard? Is your
                  home located in the city, the suburbs, or out in the country?
                  Do you have other pets?
                  <br />
                  <br />
                  Next, think about your family’s day-to-day life. How often are
                  you away during the day? Are there people with special needs
                  in your home? What are their ages? Do you lead an active
                  lifestyle or do you spend your free time relaxing in front of
                  the TV? Are pet allergies a concern?
                  <br />
                  <br />
                  Now, visualize what you want your life to look like with a
                  dog. What size should your pup be? What does your feeding and
                  care budget look like? How much time do you want to spend on
                  grooming and exercise? Should your dog be a protector, a
                  companion, or both? What other characteristics are important
                  to you? Our dog breed selector is designed to help you make
                  the right choice for your unique lifestyle and needs.
                </p>
              </div>
              {!isMobile && (
                <picture className={styles.image_B}>
                  <Image
                    src={imageDesktop2}
                    width={370}
                    height={514}
                    style={{ width: '100%', height: 'auto' }}
                    alt="Man and woman sitting with their dog by a river in nature"
                    loading="lazy"
                    placeholder="blur"
                    blurDataURL={`/_next/image?url=${imageDesktop2}&w=16&q=1`}
                  />
                </picture>
              )}
              {isMobile && (
                <picture className={styles.imgMobile}>
                  <Image
                    src={imageMobile2}
                    style={{ width: '100%', height: 'auto' }}
                    alt="Man and woman sitting with their dog by a river in nature"
                    loading="lazy"
                    placeholder="blur"
                    blurDataURL={`/_next/image?url=${imageMobile2}&w=16&q=1`}
                  />
                </picture>
              )}
            </div>

            <div className={styles.article_A}>
              <div className={styles.text_A}>
                <h2>What Is the Friendliest Dog Breed?</h2>
                <p>
                  All dogs are friendly if socialized from an early age. That
                  said, some breeds are known for their love of all people. Some
                  of these breeds with particularly outgoing personalities
                  include: the Labrador Retriever, Golden Retriever, Cavalier
                  King Charles Spaniel, Poodle (whether Standard or Toy),
                  Beagle, and Pembroke Welsh Corgi. If you are bringing home a
                  very young pup (i.e. &lt;12 weeks of age) and want to get a
                  better sense of its sociability, you should spend some time
                  with its parents, as pups often inherit their parents'
                  temperaments. If the puppy is older (i.e. 4-6 months old), you
                  can likely observe its social aptitude firsthand by spending
                  time with the puppy.
                </p>
                <h2 className={styles.subtitle}>
                  What Is a Good Breed for a First Time Owner?
                </h2>
                <p>
                  Some breeds are more suitable for first time owners than
                  others. For example, the larger breeds Labrador Retriever,
                  Golden Retriever, and Poodle have friendly temperaments and
                  are highly trainable, making them easier to manage for first
                  time owners. Amongst smaller breeds, the Maltese, Bichon
                  Frise, and Cavalier King Charles Spaniel are especially known
                  for their easygoing personalities and ability to get along
                  with all kinds of people. These small breeds are also
                  intelligent and trainable, making them easy to socialize for
                  good behavior. If you are not sure where to start, we suggest
                  consulting a veterinarian or finding your best match using our
                  Dog Breed Quiz for some suggestions.
                </p>
              </div>
              {!isMobile && (
                <picture className={styles.image_A}>
                  <Image
                    src={imageDesktop3}
                    style={{ width: '100%', height: 'auto' }}
                    width={370}
                    height={647}
                    alt="Young woman hugging a small puppy"
                    loading="lazy"
                    placeholder="blur"
                    blurDataURL={`/_next/image?url=${imageDesktop3}&w=16&q=1`}
                  />
                </picture>
              )}
              {isMobile && (
                <picture className={styles.imgMobile}>
                  <Image
                    src={imageMobile3}
                    style={{ width: '100%', height: 'auto' }}
                    alt="Man and woman sitting with their dog by a river in nature"
                    loading="lazy"
                    placeholder="blur"
                    blurDataURL={`/_next/image?url=${imageMobile3}&w=16&q=1`}
                  />
                </picture>
              )}
            </div>

            <div className={styles.article_B}>
              <div className={styles.text_B}>
                <h2>What Dogs Are Not for First Time Owners?</h2>
                <p>
                  Some dog breeds can be hard to train, excessively energetic,
                  or prone to aggressive behavior. These breeds of dogs are
                  typically not optimal for inexperienced owners. Breeds such as
                  the Siberian Husky can be independent and aloof, making them
                  harder to train. Other breeds such as German Shepherd Dogs,
                  Doberman Pinschers, Rottweilers and American Staffordshire
                  Terriers can be very protective, and sometimes aggressive if
                  not trained properly. Their owners should be experienced
                  raising dogs and know how to train and socialize such breeds.
                  Other breeds such as Greyhounds are extremely high energy and
                  require very frequent exercise. These breeds can be a fit for
                  first time owners, but require families that have time to
                  dedicate towards physical stimulation of their dogs. Other
                  breeds that are known to be more difficult for first time
                  owners (for some of the same reasons mentioned above) include
                  Weimaraners, Akitas, Chow Chows, Komondors, and Saint
                  Bernards.
                </p>
              </div>
              {!isMobile && (
                <picture className={styles.image_B}>
                  <Image
                    src={imageDesktop4}
                    style={{ width: '100%', height: 'auto' }}
                    alt="Woman and dog giving each other high five"
                    loading="lazy"
                    placeholder="blur"
                    blurDataURL={`/_next/image?url=${imageDesktop4}&w=16&q=1`}
                  />
                </picture>
              )}
              {isMobile && (
                <picture className={styles.imgMobile}>
                  <Image
                    src={imageMobile4}
                    style={{ width: '100%', height: 'auto' }}
                    alt="Woman and dog giving each other high five"
                    loading="lazy"
                    placeholder="blur"
                    blurDataURL={`/_next/image?url=${imageMobile4}&w=16&q=1`}
                  />
                </picture>
              )}
            </div>
            <div style={{ paddingRight: '30px' }}>
              <h2>Find Your Perfect Match with our Dog Breed Quiz</h2>
              <p>
                We know there’s a lot to think about, but don’t worry. Our Dog
                Breed Quiz will help you find your perfect breed match in
                seconds. Simply answer a short series of questions and we’ll
                provide the list of ideal dog breeds for your lifestyle. Let’s
                get started!
              </p>
            </div>
          </InView>
        </div>
        <div className={styles.sectionButton}>
          <Button
            title="Start quiz"
            theme={['pink-solid', 'large']}
            onClick={() => {
              setInitQuiz(true)
              window.scrollTo(0, 0)
            }}
            style={{ width: '300px' }}
          />
        </div>
      </section>
    </div>
  )
}
